<template>
    <div :style="{width: width}" class="inner-file">
        <label :style="{width: width, cursor: readonly ? 'default' : 'pointer'}" class="label-input mb-0" for="file-input">{{ fileName }}
            <input ref="fileInput" :style="{cursor: readonly ? 'default' : 'pointer'}" type="file" id="file-input" class="input-file"
                   v-on:change="fileChanged($event)" v-if="!readonly">
        </label>
        <div class="invalid-msg" v-if="v$.value.$error">
            <template v-if="v$.value.required.$invalid">Загрузите файл</template>
        </div>
        <a href="javascript:" :style="{ right: readonly ? '16px' : '48px' }" class="btn-d" v-if="validFile()"
           @click.prevent="downloadFile(getFile())"><i class="fa fa-download"></i></a>
        <a href="javascript:" v-if="!iconCloseBtn && !readonly" class="btn" title="Удалить" @click="deleteFile" ><i
            class="fa fa-times"></i></a>
    </div>
  <progress class="px-2" v-if="fileProgress > 0 && fileProgress != 100" id="progressBar" :value="fileProgress" max="100" :style="{width: width}"></progress>


</template>

<script>
import FileAPI from "../../modules/file/api";
import Constants from "../constants";
import {useVuelidate} from "@vuelidate/core";
import {requiredIf} from "@vuelidate/validators";
import axios from "axios";

export default {
    name: "FileUpload",
    props: {
        label: {
            type: String,
            default: "Выберите файл"
        },
        width: String,
        entity: Object,
        propName: String,
        entityIndex: Number,
        readonly: Boolean,
        required: {
          type: Boolean,
          default: false
        },
        iconCloseBtn: {
          type: Boolean,
          default: false
       }
    },
    emits: ['uploaded', 'deleteFile'],
    data () {
      return {
        value: null,
        total: null,
        totalLength: null,
        fileProgress: 0
      };
    },
    created() {
      this.value = this.entity ? this.entity[this.propName] : null;
    },
    watch: {
      entity(newValue) {
        console.log(newValue);
        this.value = newValue ? newValue[this.propName] : null;
      }
    },
    methods: {
        deleteFile() {
          if(this.$refs.fileInput.value) {
            try{
              this.$refs.fileInput.value = '';
            }catch(err){ 
              console.log(err);
            }
          }

          this.$emit('deleteFile');
        },
        getFile() {
            return this.entity[this.propName];
        },
        validFile() {
          return this.entity[this.propName] && this.entity[this.propName].id;
        },
        downloadFile(file) {
            FileAPI.download(file.id)
                .then(response => {
                    const blob = new Blob([response.data], {type: file.fileType});
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = file.originalName;
                    link.click();
                    URL.revokeObjectURL(link.href);
                });
        },
        fileChanged(e) {
            const file = e.target.files[0];
            // const onProgress = (progressEvent) => {
            //   this.total = progressEvent.total
            //   this.totalLength = progressEvent.lengthComputable ? this.total : null
            //   console.log(this.total, this.totalLength)
            // }

          if(file === undefined)
            return;

            let formData = new FormData();
            formData.append('file', file);
           axios.post( '/api/file/upload',
                formData,
                {
                  onUploadProgress: (progressEvent) => {
                    const total = progressEvent.total
                    const totalLenght = progressEvent.lengthComputable ? total : null;
                    console.log(total, totalLenght)
                    if(totalLenght != null) {
                      this.fileProgress = Math.round((progressEvent.loaded * 100) / total)

                    }
                  },
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                },
            ).then((response) => {
             this.value = file;
             this.$emit('uploaded', {
               entityIndex: this.entityIndex,
               propName: this.propName,
               data: response.data
             });
           }).catch(() => {
             Constants.alert.fire('Ошибка', 'Не удалось загрузить файл.', 'error');
           })
            //FileAPI.upload(file)
            //     .then((response) => {
            //         this.value = file;
            //         this.$emit('uploaded', {
            //             entityIndex: this.entityIndex,
            //             propName: this.propName,
            //             data: response.data
            //         });
            //     }).catch(() => {
            //     Constants.alert.fire('Ошибка', 'Не удалось загрузить файл.', 'error');
            // })
        }
    },
    computed: {
        fileName() {
            return this.validFile() ? this.entity[this.propName].originalName : this.label
        }
    },
    setup: () => ({v$: useVuelidate()}),
    validations() {
      return {
        value: {
          required: requiredIf(function () {
            return this.required
          }),
        }
      }
    }
}
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
::-webkit-file-upload-button {
    cursor:pointer;
}
input[type=file] {
    cursor:pointer;
}
.input-file {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: 0;
    background: $gray-medium;
    border-radius: 6px;
    z-index: 2;
}

label {
    position: relative;
    cursor: pointer;
    font-family: "Roboto", sans-serif;
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;
    line-height: 140%;
    color: #333333;
    padding: 5px 16px;
    width: 320px;
    height: 40px;
    background: #F5F5FA;
    border-radius: 6px;
    z-index: 3;
}
a:focus{
    box-shadow: none !important;
    outline: none !important;
}
.inner-file {
    min-width: 250px;
    position: relative;
    background: #F5F5FA;
    border-radius: 6px;
    z-index: 1;

    .btn {
        cursor: pointer;
        position: absolute;
        content: "";
        width: 24px;
        height: 24px;
        top: 0;
        right: 24px;
        z-index: 99;
    }
    .btn-d{
        cursor: pointer;
        position: absolute;
        content: "";
        width: 24px;
        height: 24px;
        top: 50%;
        right: 48px;
        z-index: 99;
        transform: translateY(-55%);
    }
}

.fa-times {
    color: $red-dark;
}
.fa-download{
    color: $blue-light
}
.invalid-msg {
  background-color: $white;
}
</style>